import { Theme } from '@mui/material';
import { OutlinedButton } from '@shared/components';
import { UploadIcon } from '@shared/custom-icons';
import { useProductsTFunction } from '@retail/products/i18n';

interface Props {
  onClick: () => void;
}

export function ItemIdentifiersFilterButton({ onClick }: Props) {
  const t = useProductsTFunction();

  return (
    <OutlinedButton
      size="small"
      fullWidth
      startIcon={<UploadIcon fontSize="small" />}
      onClick={onClick}
      sx={(theme: Theme) => ({
        justifyContent: 'flex-start',
        color: theme.vars.palette.text.secondary,
        '& .MuiButton-startIcon': {
          marginRight: 1.5,
          '& > *:nth-of-type(1)': {
            fontSize: 14,
            color: theme.vars.palette.primary.light,
          },
        },
        '&:hover .MuiButton-startIcon > *:nth-of-type(1)': {
          color: 'inherit',
        },
      })}
    >
      {t('products.itemIdentifiersFilter.button')}
    </OutlinedButton>
  );
}
